import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: center;

  p {
    min-width: 50px;
    text-align: center;
    color: ${(props) => props.theme.colors.inactive};
    cursor: default;
  }
  
  button {
    position: relative;
    width: 32px;
    
    i {
      position: absolute;    
      top: 8px;
      left: 9px;
    }
    
    :not(:disabled):hover i{
      margin-left: 6px;
      transition: all .2s ease-in;
      
      path {
        stroke: ${(props) => props.theme.colors.main_cta};
      }
    }
  }
  
  button:first-of-type{
    transform: rotate(180deg);
  }
`;

export default { Wrapper };
